export const Domain = import.meta.env.VIDEO_URL;
// export const BASE_URL = import.meta.env.VITE_API_URL || "https://csi-anuragd/";
// console.log("first", BASE_URL, );

export const BASE_URL = window.VITE_API_URL;
const BASE_SIGNALR_URL = `${BASE_URL}/VCCCustomerPortal/signalr`;

export const API_URL = {
    GET_LANGUAGE: `${BASE_URL}/VCCStatService/routing/availability/tset/Language?customerName=test&skillType=Language`,
    POST_RoutingInteraction: `${BASE_URL}/VCCCustomerPortal/Routing.asmx/routeInteractionRev`,
    POST_routeInteractionSwitchLanguageRev: `${BASE_URL}/VCCCustomerPortal/Routing.asmx/routeInteractionSwitchLanguageRev`,

    // OTP API endpoints
    SEND_OTP: `https://nrivideochat.canarabank.bank.in/VCCCustomerPortal/Routing.asmx/validateNRICustomerRev`,

    NEGOTIATE_URL : `${BASE_SIGNALR_URL}/negotiate`,
    START_URL : `${BASE_SIGNALR_URL}/start`,
    POST_GETINTERACTION: `${BASE_URL}/VCCCustomerPortal/Routing.asmx/getInteractionStatus`,
    ABORT_URL:`${BASE_SIGNALR_URL}/abort`,

    // Agent Connect API endpoints
    UPDATE_ROOM_STATUS: `${BASE_URL}/VCCCustomerPortal/Routing.asmx/UpdateRoomStatus`,
    TOKEN_SERVER: `${BASE_URL}/VCCStatService/token/`,
    RTC_SIG_SERVER: `${BASE_URL}/rtcsig/`,

    // chat  API endpoints
    API_ALL_CHAT: `${BASE_URL}/VCCStatService/chat/AllChat`,
    API_INSERT_CHAT: `${BASE_URL}/VCCStatService/chat/insertChat`,
}